import * as React from "react";
import { IconProps } from "../../types/common";

interface Props extends IconProps {
  fill?: string;
  stroke?: string;
}

export const DiamondIcon: React.FC<Props> = (props) => {
  const { width = "24", height = "24", fill, stroke } = props;

  return (
    <svg
      width={width}
      height={height}
      stroke="none"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      id="diamond"
    >
      <path
        d="M3.08,18.38c0.01,0.04,0.04,0.06,0.06,0.1c0.04,0.07,0.07,0.14,0.12,0.2l20,22c0.01,0.02,0.04,0.02,0.05,0.04
          c0.07,0.07,0.15,0.12,0.23,0.17c0.03,0.02,0.06,0.03,0.09,0.05C23.75,40.97,23.87,41,24,41s0.25-0.03,0.36-0.08
          c0.03-0.01,0.06-0.03,0.09-0.05c0.09-0.04,0.16-0.1,0.23-0.17c0.02-0.02,0.04-0.02,0.05-0.04l20-22c0.05-0.06,0.09-0.13,0.12-0.2
          c0.02-0.03,0.05-0.06,0.06-0.1c0.05-0.12,0.07-0.24,0.07-0.36c0-0.01,0-0.01,0-0.01c0-0.03-0.01-0.06-0.02-0.09
          c-0.01-0.09-0.02-0.18-0.05-0.26c-0.02-0.05-0.05-0.09-0.08-0.14c-0.03-0.04-0.04-0.09-0.07-0.14l-8-10
          c-0.01-0.01-0.03-0.02-0.04-0.03c-0.06-0.07-0.14-0.12-0.22-0.17c-0.04-0.03-0.08-0.06-0.12-0.08c-0.01-0.01-0.02-0.02-0.03-0.02
          c-0.1-0.04-0.19-0.05-0.29-0.05C36.05,7.02,36.03,7,36,7H12c-0.03,0-0.06,0.02-0.09,0.02c-0.09,0.01-0.19,0.01-0.28,0.05
          c-0.01,0-0.02,0.02-0.03,0.02c-0.05,0.02-0.08,0.05-0.12,0.08c-0.08,0.05-0.16,0.1-0.22,0.17c-0.01,0.01-0.03,0.02-0.04,0.03l-8,10
          c-0.03,0.04-0.05,0.09-0.07,0.14c-0.03,0.05-0.06,0.09-0.08,0.14c-0.03,0.09-0.05,0.17-0.05,0.26C3.01,17.94,3,17.97,3,18
          c0,0.01,0,0.01,0,0.01C3,18.14,3.03,18.26,3.08,18.38z M6.26,19h9.04l6.03,16.57L6.26,19z M24,37.07L17.43,19h13.14L24,37.07z
          M26.67,35.57L32.7,19h9.04L26.67,35.57z M36.29,9.96L41.92,17h-8.44L36.29,9.96z M34.52,9l-2.81,7.04L26.08,9H34.52z M29.92,17
          H18.08L24,9.6L29.92,17z M21.92,9l-5.63,7.04L13.48,9H21.92z M11.71,9.96L14.52,17H6.08L11.71,9.96z"
        fill={fill}
        stroke={stroke}
      ></path>
    </svg>
  );
};

DiamondIcon.defaultProps = {
  stroke: "currentColor",
  fill: "currentColor",
};
